// One layout for both site modes.
export const CONTACT_PAGE_KEY = "contact_us";

export const CONTACT_MAP_URL =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d7975.85217825692!2d103.85141638029147!3d1.2902356818871847!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19b6a358b8fb%3A0x3187729d77288a41!2s10%2010%20High%20Street%20Centre%201%20North%20Bridge%20Rd%2C%20Singapore%20179094!5e0!3m2!1sen!2sca!4v1624308918396!5m2!1sen!2sca";

// Keep in sync with web_admin/src/views/pages/PageBuilder/sectionSchemas.js.
// Empty fonts mean "keep the site fonts", so nothing changes until an admin picks one.
export const DEFAULT_CONTACT_LAYOUT = {
  theme: {
    headingFont: "",
    bodyFont: "",
    primaryColor: "#EC1F24",
  },
  sections: [
    {
      id: "title",
      type: "contactTitle",
      visible: true,
      style: {},
      props: {
        title: "CONTACT US",
      },
    },
    {
      // Contact icons are fixed by position (email, phone, address); only the text changes.
      id: "details",
      type: "contactDetails",
      visible: true,
      style: {},
      props: {
        heading: "GET IN TOUCH WITH US",
        text: "Have questions or need assistance? We're here to help! Reach out to our support team for any inquiries about our platform, services, or features. We're committed to providing you with the best experience.",
        contacts: [
          { title: "connect@kuvuma.com", detail: "" },
          { title: "Tel: +254 797 771771", detail: "" },
          {
            title: "INTEGRAL MEDIA LIMITED",
            detail: "Jadala Place, 1st FloorNgong Lane, Off Ngong Road",
          },
        ],
        mapUrl: CONTACT_MAP_URL,
      },
    },
    {
      id: "form",
      type: "contactForm",
      visible: true,
      style: {},
      props: {
        nameLabel: "Full Name",
        namePlaceholder: "Enter your name",
        emailLabel: "Email Address",
        emailPlaceholder: "Enter email address",
        phoneLabel: "Mobile Number",
        phonePlaceholder: "Enter Mobile Number",
        messageLabel: "Message",
        messagePlaceholder: "",
        buttonLabel: "Send",
        successMessage: "Query sent successfully",
      },
    },
  ],
};
